import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import pinia from './stores';
import { DtScrollbarDirective, DtTooltipDirective } from '@dialpad/dialtone/vue3';

//  Import Global Styles
import '@dialpad/dialtone/css';
import '@dialpad/dialtone/css-default-theme';
import './styles/main.less';

const app = createApp(App);

app.use(pinia);
app.use(router);
app.use(DtScrollbarDirective);
app.use(DtTooltipDirective);

app.mount('#app');
